import script from "./DsAttendanceSheetMirror.vue?vue&type=script&setup=true&lang=ts"
export * from "./DsAttendanceSheetMirror.vue?vue&type=script&setup=true&lang=ts"

import "./DsAttendanceSheetMirror.vue?vue&type=style&index=0&id=77b828b8&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77b828b8"]])

export default __exports__